import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Wix = forwardRef<SVGSVGElement, IconProps>(({ color = '#000000', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g clipPath="url(#clip0_3800_263)">
        <mask
          id="mask0_3800_263"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="1"
          y="8"
          width="22"
          height="8"
        >
          <path d="M22.9079 8H1V16H22.9079V8Z" fill="white" />
        </mask>
        <g mask="url(#mask0_3800_263)">
          <path
            d="M22.9078 8H21.6976C21.3619 8 21.0482 8.15679 20.8596 8.419L19.2413 10.6708C19.1981 10.7305 19.1047 10.7305 19.0616 10.6708L17.4431 8.419C17.2549 8.15679 16.9409 8 16.6052 8H15.395L18.2781 12.0112L15.4109 16H16.6211C16.9568 16 17.2706 15.8432 17.4592 15.581L19.0616 13.3516C19.1047 13.2919 19.1981 13.2919 19.2413 13.3516L20.8437 15.581C21.0319 15.8432 21.346 16 21.6817 16H22.8919L20.0248 12.0112L22.9078 8Z"
            fill={color}
          />
          <path
            d="M12.905 8.81832V16H13.4834C13.9627 16 14.3512 15.6337 14.3512 15.1817V8H13.7728C13.2934 8 12.905 8.36629 12.905 8.81832Z"
            fill={color}
          />
          <path
            d="M11.8446 8H11.3299C10.7632 8 10.2722 8.36963 10.1467 8.8907L8.99525 13.6648L7.98744 9.20829C7.80102 8.38464 6.905 7.8292 5.9881 8.06805C5.40407 8.22017 4.97109 8.68554 4.8448 9.24432L3.84726 13.6588L2.69795 8.89104C2.57202 8.36996 2.08103 8 1.51434 8H1L2.92895 15.9997H3.65977C4.32303 15.9997 4.89609 15.5623 5.03442 14.9505L6.26756 9.49251C6.28276 9.4248 6.34714 9.37575 6.42036 9.37575C6.49359 9.37575 6.55797 9.4248 6.57318 9.49251L7.80738 14.9508C7.94569 15.5626 8.51875 15.9997 9.18202 15.9997H9.91533L11.8446 8Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3800_263">
          <rect width="22" height="8" fill="white" transform="translate(1 8)" />
        </clipPath>
      </defs>
    </svg>
  )
})

export default Wix
